export default "__VITE_ASSET__BWMPeY7j__"